import { render, staticRenderFns } from "./ClickableWrapper.vue?vue&type=template&id=0d91adc8&scoped=true&"
import script from "./ClickableWrapper.vue?vue&type=script&lang=js&"
export * from "./ClickableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ClickableWrapper.vue?vue&type=style&index=0&id=0d91adc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91adc8",
  null
  
)

export default component.exports